import endpoints from "../config/endpoints";
import api from "../config/axios";

export const GetAllOrder = async (params) => {
    try {
        const query = new URLSearchParams(params).toString();
        const response = await api.get(`${endpoints.Order.GetAllOrders}?${query}`);

        return {
            data: response.data.data || [],
            status: response.data.status,
            statusCode: response.data.statusCode,
            message: response.data.message,
        };
    } catch (error) {
        console.error('Error fetching orders:', error);
        return {
            data: { orders: [], pending: 0, processing: 0, outForDelivery: 0, completed: 0 },
            status: false,
            statusCode: 500,
            message: 'Error fetching orders',
        };
    }
};

export const GetDashboardCounts = async (vendorId, startDate, endDate) => {
    try {
        const params = {};
        if (vendorId) params.vendorId = vendorId;
        if (startDate) params.startDate = startDate;
        if (endDate) params.endDate = endDate;
        const query = new URLSearchParams(params).toString();
        const url = `${endpoints.Order.GetDashboardCounts}${query ? `?${query}` : ""}`;
        const response = await api.get(url);

        return {
            data: response.data.data || [],
            status: response.data.status,
            statusCode: response.data.statusCode,
            message: response.data.message,
        };
    } catch (error) {
        console.error('Error fetching counts:', error);
        return {
            data: { userCount: 0, productCount: 0, orderCount: 0 },
            status: false,
            statusCode: 500,
            message: 'Error fetching dashboard counts',
        };
    }
};

export const UpdateOrderStatus = async (orderId, status) => {
    try {
        const formData = new FormData();
        formData.append("id", orderId);
        formData.append("orderStatus", status);
        const response = await api.put(endpoints.Order.UpdateOrderStatus, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });

        return {
            data: response.data.data || [],
            status: response.data.status,
            statusCode: response.data.statusCode,
            message: response.data.message,
        };
    } catch (error) {
        console.error('Error updating order status:', error);
        return {
            data: [],
            status: false,
            statusCode: 500,
            message: 'Error updating order status',
        };
    }
};

export const CreateOrder = async (orderData) => {
    try {
        const response = await api.post(endpoints.Order.Create, orderData);
        return {
            data: response.data.data || null,
            status: response.data.status,
            statusCode: response.data.statusCode,
            message: response.data.message,
        };
    } catch (error) {
        console.error('Error creating order:', error);
        return {
            data: null,
            status: false,
            statusCode: 500,
            message: error.response?.data?.message || 'Error creating order',
        };
    }
};

const orderService = {
    GetAllOrder,
    GetDashboardCounts,
    UpdateOrderStatus,
    CreateOrder
};

export default orderService;